const MedikaTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      "#969db5",
        primary2color:      "#c1d0e7",
        primary3color:      "#efefef",
        accent1color:       "#b3e5fc",
        accent2color:       "#b3e0db",
        accent3color:       "#f0f5c4",
        accent4color:       "#a9bad4", // Active breadcrumb color
        accent5color:       "#fe271b", // Button color
        textColor:          "#3B5576",
        canvasColor:        "#ffffff",
        alternateTextColor: "#ffffff",
    }
};

export default MedikaTheme;


/** WEBPACK FOOTER **
 ** ./src/themes/MedikaTheme.js
 **/